import { Component } from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent extends BaseComponent {}
